module.exports = __webpack_public_path__ + "static/TrustWallet-3429a0222acc2c0447104f6eaf9ba49b.png";